import React, { Component } from 'react'
import { translate } from '../Services/translation'
import VehicleFinder from '../Components/VehicleFinder'
import VehicleData from '../Components/VehicleData'
import withVehicleFinder from '../HOC/withVehicleFinder'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { get } from '../Services/http'
import DimensionSearch from '../Components/DimensionSearch'
import LoadingOverlay from '../Components/LoadingOverlay'
import constants from '../constants'

class VehicleFinderContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedSize: undefined,
            dimensionFilters: [],
            loading: false,
            showInfo: false,
            noSelectionOpen: false,
        }
        this.modalRef = React.createRef()
        this.elementRef = React.createRef()
        this.getTireQueryFilters = this.getTireQueryFilters.bind(this)
        this.getCompleteWHeelsQueryFilters =
            this.getCompleteWHeelsQueryFilters.bind(this)
        this.handleRemoveVehicle = this.handleRemoveVehicle.bind(this)
        this.handleNoSelectionModal = this.handleNoSelectionModal.bind(this)
        this.handleOnClick = this.handleOnClick.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        get('/api/vehicleFinder/GetDimensionFilters')
            .then((res) => res.json())
            .then((data) => {
                if (this.elementRef.current != null)
                    this.setState({ dimensionFilters: data })
            })
            .catch((e) => console.log(e))

        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentDidUpdate(prevProps) {
        if (prevProps != this.props && this.props.vehicleFinder?.vehicleData) {
            window.scrollTo({
                top: this.elementRef?.current?.offsetTop - 130,
                behavior: 'smooth',
            })
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    getTireQueryFilters() {
        const { vehicleData } = this.props.vehicleFinder
        const { selectedSize } = this.state
        if (!selectedSize || !vehicleData) return ''

        const selectedTireSize = vehicleData.tires.find(
            (tire) => tire.diameter == selectedSize
        )
        return `?${constants.filterTags.height}=${selectedTireSize.profile}&${constants.filterTags.diameter}=${selectedTireSize.diameter}&${constants.filterTags.widthInMm}=${selectedTireSize.width}`
    }

    getRimQueryFilters() {
        const { vehicleData } = this.props.vehicleFinder
        const { selectedSize } = this.state
        if (!selectedSize || !vehicleData) return ''

        return `?${constants.filterTags.diameter}=${selectedSize}`
    }

    getCompleteWHeelsQueryFilters() {
        const { vehicleData } = this.props.vehicleFinder
        const { selectedSize } = this.state
        if (!selectedSize || !vehicleData) return ''
        if (Object.keys(vehicleData.selectedProducts).length == 0)
            return `?${constants.filterTags.diameter}=${selectedSize}`
        return ''
    }

    handleRemoveVehicle() {
        this.setState({ selectedSize: undefined })
        this.props.removeVehicle()
    }

    handleNoSelectionModal(value) {
        this.setState({ noSelectionOpen: value })
    }

    handleOnClick(e) {
        if (!this.state.selectedSize) {
            this.setState({ noSelectionOpen: true })
            e.preventDefault()
            e.stopPropagation()
        }
    }

    handleClickOutside(event) {
        if (
            this.modalRef.current &&
            !this.modalRef.current.contains(event.target)
        ) {
            this.setState({ noSelectionOpen: false })
        }
    }

    render() {
        const { vehicleData, errors } = this.props.vehicleFinder
        const tireUrl =
            this.props.tireCategoryPageUrl + this.getTireQueryFilters()
        const rimUrl = this.props.rimCategoryPageUrl + this.getRimQueryFilters()
        const completeWheelsUrl =
            this.props.completeWheelsPageUrl +
            this.getCompleteWHeelsQueryFilters()
        let filters = {}
        this.state.dimensionFilters?.forEach((filter) => {
            filters[filter.id] = filter
        })

        return (
            <>
                <div
                    ref={this.elementRef}
                    className={
                        'columns small-12 medium-6 large-5 vehicle-finder' +
                        (!vehicleData ? ' align-items-top' : '')
                    }
                >
                    {!vehicleData && !this.props.moveOnWithoutVehicle && (
                        <>
                            <div className="small-12 vehicle-finder__title-container">
                                <h1 className="vehicle-finder__title">
                                    {translate('ecom.startpage.title')}
                                </h1>
                            </div>
                            <VehicleFinder
                                vehicleData={vehicleData}
                                errors={errors}
                                handleRegNoInputChange={
                                    this.props.handleRegNoInputChange
                                }
                                getVehicleDataByRegNo={
                                    this.props.getVehicleDataByRegNo
                                }
                                handleRegNoInputClick={
                                    this.props.handleRegNoInputClick
                                }
                                regNo={this.props.regNo}
                                getVehicleDataByVehicleSelector={
                                    this.props.getVehicleDataByVehicleSelector
                                }
                                loading={this.props.loading}
                            />
                            {!this.props.moveOnWithoutVehicle && (
                                <div className="vehicle-finder__move-on-link">
                                    <a
                                        onClick={
                                            this.props
                                                .handleMoveonWithoutVehicleClick
                                        }
                                    >
                                        {translate(
                                            'ecom.startpage.moveonwithoutvehicle'
                                        )}
                                    </a>
                                </div>
                            )}
                        </>
                    )}

                    {vehicleData && (
                        <div style={{ color: 'white', width: '100%' }}>
                            <div style={{ width: '100%' }}>
                                <VehicleData
                                    vehicleData={vehicleData}
                                    removeVehicle={this.handleRemoveVehicle}
                                />
                                <h4
                                    style={{
                                        fontSize: '36px',
                                        marginTop: '20px',
                                        marginBottom: '30px',
                                    }}
                                    className="vehicle-finder__title"
                                >
                                    {translate(
                                        'ecom.startpage.vehiclesearchtitle'
                                    )}
                                </h4>
                                <b>{translate('ecom.startpage.choosesize')}</b>
                                <Select
                                    inputProps={{
                                        MenuProps: { disableScrollLock: true },
                                    }}
                                    value={this.state.selectedSize}
                                    onChange={(e) =>
                                        this.setState({
                                            selectedSize: e.target.value,
                                        })
                                    }
                                    displayEmpty
                                    fullWidth
                                    color={'secondary'}
                                >
                                    <MenuItem
                                        style={{
                                            height: '35px',
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                        key="empty-value"
                                        value={undefined}
                                    />
                                    {vehicleData.rims.map((rim) => (
                                        <MenuItem
                                            style={{
                                                height: '35px',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                            key={rim.diameter}
                                            value={rim.diameter}
                                        >
                                            {rim.diameter}"
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>

                            {this.state.noSelectionOpen && (
                                <div className="vehicle-finder-no-selection__container">
                                    <div
                                        ref={this.modalRef}
                                        className="vehicle-finder-no-selection__container--modal"
                                    >
                                        {translate('vehiclefinder.noselection')}
                                        <button
                                            onClick={() =>
                                                this.handleNoSelectionModal(
                                                    false
                                                )
                                            }
                                        >
                                            {translate('close')}
                                        </button>
                                    </div>
                                </div>
                            )}

                            <div className="selection-container-test">
                                <MoveOnLinks
                                    onClick={this.handleOnClick}
                                    tireUrl={tireUrl}
                                    rimUrl={rimUrl}
                                    completeWheelsUrl={completeWheelsUrl}
                                />
                            </div>
                        </div>
                    )}

                    {this.props.moveOnWithoutVehicle &&
                        (this.state.dimensionFilters.length > 0 ? (
                            <div style={{ width: '100%' }}>
                                <a
                                    onClick={this.props.handleGoBack}
                                    style={{ color: 'white' }}
                                >
                                    {translate('ecom.startpage.goback')}
                                </a>
                                <DimensionSearch
                                    infoPopupImage={
                                        this.props.tireDimensionImage
                                    }
                                    infoPopupContent={
                                        this.props.tireDimensionContent
                                    }
                                    onMoveOn={() =>
                                        this.setState({ loading: true })
                                    }
                                    filters={filters}
                                    tireUrl={this.props.tireCategoryPageUrl}
                                />
                            </div>
                        ) : (
                            <div className="dimension-search-loading">
                                <div className="lds-ring">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        ))}
                </div>
                <div
                    id="vehicleFinderImage"
                    className="small-12 medium-6 large-7 vehicle-finder__image-container hide-for-small-only"
                    style={{
                        backgroundImage:
                            'url(' + this.props.bannerImageUrl + ')',
                    }}
                >
                    <span
                        className="vehicle-finder__image-text"
                        style={{ color: this.props.textColor }}
                        dangerouslySetInnerHTML={{ __html: this.props.text }}
                    ></span>
                </div>
                <LoadingOverlay loading={this.state.loading} />
            </>
        )
    }
}

const MOVE_ON_LINK_CATEGORY = {
    TIRE: 'tire',
    RIM: 'rim',
    COMPLETE_WHEELS: 'completewheels',
}

function MoveOnLink({ href, category, onClick }) {
    return (
        <a href={href} onClick={onClick}>
            <button>{translate(`ecom.startpage.${category}link.title`)}</button>
        </a>
    )
}

function MoveOnLinks({ tireUrl, rimUrl, completeWheelsUrl, onClick }) {
    return (
        <>
            <MoveOnLink
                onClick={onClick}
                href={completeWheelsUrl}
                category={MOVE_ON_LINK_CATEGORY.COMPLETE_WHEELS}
            />
            <MoveOnLink
                onClick={onClick}
                href={tireUrl}
                category={MOVE_ON_LINK_CATEGORY.TIRE}
            />
            <MoveOnLink
                onClick={onClick}
                href={rimUrl}
                category={MOVE_ON_LINK_CATEGORY.RIM}
            />
        </>
    )
}

export default withVehicleFinder(VehicleFinderContainer)
